export const buildPlaceOrderPayload = (payload) => ({
    json_data: payload,
});
